export default customElements.define('w-wrapper', class Wrapper extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'o-wrapper';
        const config = {
            styleSelector,
            templateHTML: `<div class="${styleSelector}__container" data-root></div>`,
            hasChildren: true
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('reduced', {
                default: false,
                type: wealthify.propTypes.Boolean()
            })
        ];
    }

    get propCallbacks () {
        return {reduced: () => {
            const classListAction = this.reduced ? 'add' : 'remove';

            this.classList[classListAction](`${this.styleSelector}--reduced`);
        }};
    }

});